import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { globalCatalog } from "../../../../redux/global-catalog/action";
import { selectGlobalCatalogListItems } from "../../../../redux/global-catalog/selector";



const GlobalCatalogInfoComponent = () => {

	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const globalCatalogItems = useSelector(selectGlobalCatalogListItems)
    const [storedItems, setStoredItems] = useState<any>({});

    useEffect(() => {
        const storedValue = localStorage.getItem('storageKey');
        if (storedValue) {
            try {
                const parsedValue = JSON.parse(storedValue);
                setStoredItems(parsedValue.items || []);
            } catch (error) {
                console.error("Error parsing JSON from localStorage:", error);
            }
        } else {
            console.log("No stored value found");
        }
    }, []);
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          {
            field: 'Image',
        headerName: 'Image',
        sortable: false,
        filter: false,
        cellRenderer: 'imageRenderer',
        filterType: 'text',
          },
          {
            field: 'Name',
            headerName: 'Name',
            sortable: true,
            filter: true,
          },
          {
            field: 'Price',
            headerName: 'Price',
            sortable: true,
            isCurrencyValueFormat: true,
          },
          { field: 'StockQuantity', headerName: 'StockQuantity' },
          {
            field: 'IsPublished',
            headerName: 'Published',
            cellRenderer: 'yesNoRenderer',
          },
          {
            field: 'VendorName',
            headerName: 'Vendor',
            sortable: true,
          },
          {
            field: 'CreatedOnUtc',
            headerName: 'Created On',
            isDateValueFormat: true,
            sortable: true,
          },
       
        ]);
      }
      useEffect(() => {
        console.log("Fetched policyItems:", globalCatalogItems);
      }, [globalCatalogItems]);
      const formatRowData = () => {
        if (!Array.isArray(globalCatalogItems?.result?.items)) {
          return [];
        }
      
       return globalCatalogItems.result.items.flatMap((item: any) => {
        
            return item.Products?.map((product: any) => ({
              Id: product?.Id,
              Name: product?.Name || "",
              VendorName: product?.VendorName || "",
              Price: product?.Price || "",
              IsPublished: product?.IsPublished || "",
              StockQuantity: product?.StockQuantity || 0,
              Image: product?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL || "",
              CreatedOnUtc: product?.CreatedOnUtc || "",
            })) || [];
        
        });
      };
      const fetchGlobalCatalog=()=>{
        dispatch(globalCatalog.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/global/fetch-detail`,entity:'globalCatalog',jsonData:{
           "Context": {},
                "Records": [
                    {
                    "Id": 0,
                    "AccountId": storedItems?.AccountId
                    }
  ]
        }}))
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
       navigate(`${data.GlobalOrgRegistryId}`)
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(globalCatalog.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/global/fetch-detail`,entity:'globalCatalog',jsonData:{
      
            "Context": {},
            "Records": [
                {
                  "Id": 0,
                  "AccountId": storedItems?.AccountId
                }
]
      
          }}))
      }
    
      
	useEffect(() => {
    if(storedItems?.Id){
        createColumnDefs()
        fetchGlobalCatalog()
    }
	}, [pageData,pageSize,storedItems])

  
	return (
    <>
    {globalCatalogItems?.isLoading ?  <PageLoader />: 
		<Table columnData={columnDefs}
    onSearch={handleSearch}rowData={formatRowData()} setPageData={setPageData}
    paginationData={globalCatalogItems?.result?.pagination}
    onEdit={handleEdit}  setPageSize={setPageSize}headingName="Global Catalog"/>
     
  }
  </> 
	);
};

export default GlobalCatalogInfoComponent;


